// Run timer (top centre): big mono digits with a chip naming the run.

import { formatTime } from '../../game/settings';
import { el, setText } from './dom';

export class Timer {
  readonly root = el('div', 'hud-timer');
  private readonly chip = el('div', 'hud-timer-run');
  private readonly time = el('div', 'hud-timer-time');

  constructor() {
    this.root.append(this.chip, this.time);
  }

  update(timer: { run: string; time: number; label?: string } | null): void {
    this.root.classList.toggle('idle', !timer);
    if (!timer) return;
    setText(this.chip, timer.label ?? (timer.run === 'default' ? 'TIMERUN' : timer.run));
    setText(this.time, formatTime(Math.max(0, timer.time)));
  }
}
